'use client';

import LinkButtonStrapi, {
  LinkButtonStrapiProps,
} from '@/components/atoms/LinkButton/LinkStrapi';
import { useTrackPricingCardClick } from '@/hooks/useTrackPricingCardClick';

type Props = {
  cardCta: LinkButtonStrapiProps;
  cardTitle?: string;
};

const ContentSplitCTA = ({ cardCta, cardTitle }: Props) => {
  const trackId = cardTitle?.trim().toLowerCase().replace(/\s+/g, '_');

  const handleClick = useTrackPricingCardClick({
    trackEventName: 'homepage_hero_content_split_cta_click',
    trackId,
    trackExtra: {
      ...(cardTitle && { title: cardTitle }),
      ...(cardCta?.url && { url: cardCta.url }),
      ...(cardCta?.text && { buttonText: cardCta.text }),
    },
  });

  return (
    <LinkButtonStrapi
      block={cardCta}
      inner={{
        size: 'l',
        fullwidth: true,
        'data-tracker-context': trackId,
        onClick: () => handleClick(),
      }}
    />
  );
};

export default ContentSplitCTA;
